import React from "react";
import { ServiceMain } from "../../styles/services";
import {
  StepDiv,
  StepMainDiv,
} from "../../styles/homeComp/toolstyles";
import { RiChatPollLine, RiCodepenFill, RiDatabaseLine, RiFlashlightLine, RiShieldKeyholeLine, RiSpaceShipLine } from "react-icons/ri";

const Tools = () => {
  return (
    <>
      {
        <ServiceMain className="no_padding">
          <div className="header smaller_header ">
            <div className="box_header  ">
              <div className="box  no_top" />
              <div className="box  no_top" />
              <div className="box  no_top" />
            </div>
            <h2 className="header_text">Turn decisions into actions.</h2>
          </div>
          <div>
            <StepMainDiv>
              {data.map((item, index) => (
                <StepDiv key={index + ""}>
                  <div>{item.icon}</div>
                  <div className="container">
                    <div className="title">
                      <h3>{item.header}</h3>
                    </div>

                    <div className="description">
                      <p>{item.text}</p>
                    </div>
                  </div>
                </StepDiv>
              ))}
          
            </StepMainDiv>
          </div>
           <div className="empty">

      </div>
        </ServiceMain>
      }
    </>
  );
};

export default Tools;

const data = [
  {
    icon: <RiFlashlightLine />,
    header: "Scale agents at lightning speed.",
    text: "Deploy and iterate faster with a runtime built for low-latency, high-frequency AI interactions.",
  },
  {
    icon: <RiDatabaseLine />,
    header: "Log every token, prompt, and response.",
    text: "Capture structured logs from your agents to debug, monitor, and improve outputs with confidence.",
  },
  {
    icon: <RiSpaceShipLine />,
    header: "Deploy agents with confidence.",
    text: "Ship updates to your agent infrastructure with zero downtime, built-in rollbacks, and CI/CD integration.",
  },
   {
    icon: <RiChatPollLine />,
    header: "Craft conversations that feel natural",
    text: "Build agents that communicate with clarity, memory, and purpose — all customizable to your brand.",
  },
  
   {
    icon:<RiCodepenFill />
,
    header: "Custom logic. Full control.",
    text: "Write custom functions, conditionals, and handlers directly into your agents using flexible hooks.",
  },
   {
    icon: <RiShieldKeyholeLine />,
    header: "Secure by default. Configurable by design.",
    text: "Manage permissions, enforce rate limits, and protect sensitive data across every agent session",
  },
];
